import React, { useEffect, useState } from 'react'
import './Index.css';

import fetchData from '../../function/fetchData';

//SERVER ADRES
const server = process.env.REACT_APP_SERVER_ADRES;
const adresOfServer = server +"api2/infoAboutTrip.php";

// APP
const Index = ( {tokenOfTrip }) => {
    const [order, setOrder] = useState({}) 
    const [driver, setDriver] = useState({})
    const [extraTrip, setExtraTrip] = useState()
    const [listOfBreaks, setListOfBreaks] = useState()
    const status = Number(order.status)

    useEffect( () => {
        fetchData(adresOfServer, {"tokenOfTrip": tokenOfTrip})
        .then( (res) =>{
          
            setOrder(res.trip)
            setDriver(res.infoAboutDriver)
            setExtraTrip(res.extraTrip)
            setListOfBreaks(res.listOfBreaks)
        })
    },[])
    
   

  return (
    <div className=''>
        
        <div className='oneInvoice'>
            <div className="textContent">
                { (status === 5 || status === 15) &&
                    <div>
                        <h2>Doklad k Vaší jízdě č. {order.id}</h2>
                        <p>Datum: {order.date}</p>
                        <p>Firma: {order.companyContact}</p>
                        <p>Řidič: {driver.contact}</p>
                        <img src={driver.signature} style={{width: 200, height: 100}}/>
                        <p>Spz: {order.spz}</p>
            
                        <p>Ič: {driver.ic}</p>
                        <br />
           
                    </div>
                }
 
                <p>Start: {order.start}</p>
                {extraTrip && extraTrip > 0  && extraTrip.map( (oneTrip, index) => {
                     return <p key={index}>+ mezizastávka: {oneTrip.adres}</p>
                } )} 
                <p>Cíl: {order.destination}</p>
                <br />
                {listOfBreaks  && listOfBreaks.length > 0 &&(
                    <div>
                     
                        <p>+ Čekání na:</p>
                        { listOfBreaks.map( one => {
                            return (
                                <div key={one.tokenOfBreak}>
                                    <p >Čas začátku: {one.timeStart}, ukončená pauza: {one.timeEnd}</p>
                                    <p>Cena: {one.price} Kč</p>
                                    <br />
                                </div>
                                
                            )
                        })}
                     
                    </div>
                )}
                <p>Délka trasy: { (parseInt( order.tripDistance) / 1000 ).toFixed(1) } Km</p>
                {parseInt(order.promoPrice) > 0 ? <p style={{color: "red"}}>Sleva na jízdu: -{order.promoPrice} Kč</p> : ""}
           
                {parseInt(order.howToPay) === 1 ? <p>Způsob platby: kartou</p> : ""}
                {parseInt(order.howToPay) === 2 ? <p>Způsob platby: hotovost</p> : ""}
                {parseInt(order.howToPay) === 3 ? <p>Způsob platby: hotovost euro</p> : ""}
                <br />
                <div className='priceDiv' >
                    <h3 style={{color: 'white', fontWeight: 'bold'}}>Cena: {order.price} Kč</h3>
                </div>
                
            </div>
        </div>
        
    </div>
  )
}

export default Index